import React from 'react';
import ResourceList from './ResourceList';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';



let LocationTables = (props) =>{

  if (props.tables) {
  let groupedData = groupBy(props.tables,'revenueCenter');

  return (<div>
    {groupedData.map((rc,i)=>
      <div key={rc.group}>
        <Subheader>Revenue Center: {rc.group}</Subheader>
        <ResourceList 
          data={rc.items} 
          showCheckboxes={false}
          columns={[
            {name: 'revenueCenter', label: 'Revenue Center'},
            {name: 'name', label: 'Table Number'},
            {name: 'beaconId', label: 'Beacon ID'},
            {name: 'edit', label:'Edit', render: (row) => <RaisedButton onClick={() => props.showEdit(row)} label='Edit' primary={true}/>}
          ]}/>
        <Divider/>
      </div>)}
  </div>);
  }

  return <div></div>;
}


function groupBy(arrayData, prop) {
  return arrayData.reduce((groups, currentValue) => {
    if ( groups.indexOf(currentValue[prop]) === -1 ) {
      groups.push(currentValue[prop]);
    }
    return groups;
  }, []).map((group) => ({
        group: group,
        items: arrayData
                .filter(_el => _el[prop] === group)
                .map(_el=>_el)
    })
  );
}

export default LocationTables;


// WEBPACK FOOTER //
// ./src/components/LocationTables.js